<app-modal-dialog [dialogRef]="dialogRef">
    <app-assistant-header
            [title]="data.title | translate">
        <app-icon-shield [width]="20" [height]="20"/>
    </app-assistant-header>
    <!--    <ng-container title>-->
    <!--        {{data.title | translate}}-->
    <!--    </ng-container>-->
    <ng-container body>
        @if (data.sanitizeDescription) {
            <div class="text-center" [innerHTML]="data?.description | safe: 'html'"></div>
        } @else {
            <div class="text-center">{{ data?.description | translate }}</div>
        }

        @if (data?.imgUrl) {
            <div class="d-flex align-items-center justify-content-center my-1 img-container">
                <img class="cover-image rounded-inherit" [src]="data?.imgUrl | safe : 'resourceUrl' " alt="Image">
            </div>
        }
    </ng-container>
    <ng-container footer>
        <div class="mx-auto">
            <div class="d-flex justify-content-center">
                @if (data?.cancelLabel && !data?.removeCancelOption) {
                    <button class="btn btn-secondary px-3 w-30"
                            (click)="onCancel()">{{ data?.cancelLabel || ('common.cancel' | translate) }}
                    </button>&nbsp;
                }

                <button class="btn btn-primary px-3 w-30" (click)="onConfirm()">
                    {{ data?.confirmLabel || ('common.ok' | translate) }}
                </button>
            </div>
        </div>
    </ng-container>
</app-modal-dialog>
